module.exports = __webpack_public_path__ + "static/media/pentadata_logo_170.adf4e16f.png";